<template>
  <div>
    <el-col>
      <template>
        You can apply Filters on entity data by selecting entity field.
      </template>
      <div
        style="display: flex !important"
        v-if="formbuilderFiltersData && formbuilderFiltersData._id"
      >
        <p v-if="formbuilderFiltersData.filter_name">
          Selected Filter:
          <span style="font-weight: 600">{{
            formbuilderFiltersData.filter_name
          }}</span>
        </p>
        <el-tooltip
          class="item"
          effect="dark"
          content="Delete filter"
          placement="top-start"
        >
          <el-link
            class="mb-1 ml-1"
            type="danger"
            :underline="false"
            @click="deleteFilter"
          >
            <i class="el-icon-delete"></i>
          </el-link>
        </el-tooltip>
      </div>
      <el-scrollbar wrap-style="max-height: 250px;" ref="filterScroll">
        <table class="filter-table" v-if="formbuilderFiltersData.filters">
          <tr
            v-for="(filter, index) in formbuilderFiltersData.filters"
            :key="index + '-' + filter.field"
          >
            <td>
              <tr>
                <td>
                  <div style="width: 70px; margin-right: 6px">
                    <span v-if="index === 0">Where</span>
                    <el-select
                      v-else-if="index === 1"
                      v-model="formbuilderFiltersData.query_type"
                      size="mini"
                      style="width: 70px"
                    >
                      <el-option label="AND" value="AND" />
                      <el-option label="OR" value="OR" />
                    </el-select>
                    <p v-else style="margin-left: 10px">
                      {{ formbuilderFiltersData.query_type }}
                    </p>
                  </div>
                </td>
                <td v-if="filter.grouping?.groupingFilters">
                  <table
                    class="filter-table"
                    style="
                      width: 100%;
                      background: #f2f6fc;
                      border-left: 2px solid #dcdfe6;
                    "
                  >
                    <tr
                      v-for="(subFilter, subIndex) in filter.grouping
                        ?.groupingFilters"
                      :key="'sub-' + subIndex"
                      style="background: #f2f6fc"
                    >
                      <td>
                        <tr style="background: #f2f6fc">
                          <td>
                            <div style="width: 70px; margin-right: 6px">
                              <span v-if="subIndex === 0">Where</span>
                              <el-select
                                v-else-if="subIndex === 1"
                                v-model="filter.grouping.grouping_query_type"
                                size="mini"
                                style="width: 70px"
                              >
                                <el-option label="AND" value="AND" />
                                <el-option label="OR" value="OR" />
                              </el-select>
                              <p v-else style="margin-left: 10px">
                                {{ filter.grouping.grouping_query_type }}
                              </p>
                            </div>
                          </td>
                          <FormbuilderFilterRow
                            :filter="subFilter"
                            :index="subIndex"
                            :checkCurrentFieldData="checkCurrentFieldData"
                            :allFormbuilderFields="allFormbuilderFields"
                            :getCurrentFieldOperators="getCurrentFieldOperators"
                            :checkSourceDataChange="checkSourceDataChange"
                            :allowedDataSources="allowedDataSources"
                            :checkTemplateCondition="checkTemplateCondition"
                            :checkIsSelect="checkIsSelect"
                            :allowedLoginFilterOp="allowedLoginFilterOp"
                            :getSelfTemplateFieldsByType="
                              getSelfTemplateFieldsByType
                            "
                            :weekdays_options="weekdays_options"
                            :checkIsFirstRelationalField="
                              checkIsFirstRelationalField
                            "
                            :checkCurrentFieldValue="checkCurrentFieldValue"
                            :loginUserFields="loginUserFields"
                            :users="users"
                            :isFixed="isFixed"
                            :addGlobalVaraibleData="addGlobalVaraibleData"
                            :selectedGlobalVariablesList="
                              selectedGlobalVariablesList
                            "
                            :parseOptionsAsNumbers="parseOptionsAsNumbers"
                            :entilistAsOptions="entilistAsOptions"
                            :getLabel="getLabel"
                            :fieldType="fieldType"
                            :getCurrentFieldOptions="getCurrentFieldOptions"
                          >
                          </FormbuilderFilterRow>

                          <td>
                            <el-button
                              type="text"
                              size="mini"
                              @click="
                                removeFilterFromList(index, subIndex, true)
                              "
                              ><i class="el-icon-delete"></i
                            ></el-button>
                          </td>
                        </tr>
                      </td>
                    </tr>
                    <el-button
                      @click="
                        addFilter(
                          filter.grouping.groupingFilters,
                          filter.grouping.grouping_query_type
                        )
                      "
                      size="mini"
                      type="text"
                      >+ Add Filter</el-button
                    >
                  </table>
                </td>
                <template v-else>
                  <FormbuilderFilterRow
                    :filter="filter"
                    :index="index"
                    :checkCurrentFieldData="checkCurrentFieldData"
                    :allFormbuilderFields="allFormbuilderFields"
                    :getCurrentFieldOperators="getCurrentFieldOperators"
                    :checkSourceDataChange="checkSourceDataChange"
                    :allowedDataSources="allowedDataSources"
                    :checkTemplateCondition="checkTemplateCondition"
                    :checkIsSelect="checkIsSelect"
                    :allowedLoginFilterOp="allowedLoginFilterOp"
                    :getSelfTemplateFieldsByType="getSelfTemplateFieldsByType"
                    :weekdays_options="weekdays_options"
                    :checkIsFirstRelationalField="checkIsFirstRelationalField"
                    :checkCurrentFieldValue="checkCurrentFieldValue"
                    :loginUserFields="loginUserFields"
                    :users="users"
                    :isFixed="isFixed"
                    :addGlobalVaraibleData="addGlobalVaraibleData"
                    :selectedGlobalVariablesList="selectedGlobalVariablesList"
                    :parseOptionsAsNumbers="parseOptionsAsNumbers"
                    :entilistAsOptions="entilistAsOptions"
                    :getLabel="getLabel"
                    :fieldType="fieldType"
                    :getCurrentFieldOptions="getCurrentFieldOptions"
                  >
                  </FormbuilderFilterRow>
                </template>
                <td>
                  <el-button
                    type="text"
                    size="mini"
                    @click="removeFilterFromList(index)"
                    ><i class="el-icon-delete"></i
                  ></el-button>
                </td>
              </tr>
            </td>
          </tr>
        </table>
      </el-scrollbar>
      <el-button @click="addFilter()" type="text">Add Filter+</el-button>
      <el-button
        v-if="!this.$route.query.routeType"
        @click="addGroup()"
        type="text"
        >+ Add Group</el-button
      >
      <!-- <span class="warning">
        Note: The quick filters of the first
        <em>Relation-with #Entity</em> Filter will be displayed alongside the
        current filter's quick filters.
      </span>-->
      <el-divider></el-divider>
      <div
        v-if="formbuilderFiltersData.isSaveFilter || formbuilderFiltersData._id"
        class="mt-1 d-flex"
      >
        <div
          v-if="
            formbuilderFiltersData.isSaveFilter || formbuilderFiltersData._id
          "
        >
          <div style="margin-bottom: 10px">
            Filter name
            <span class="text-danger">*</span>
          </div>
          <el-input
            v-model="formbuilderFiltersData.filter_name"
            placeholder="Enter filter name"
            size="mini"
          ></el-input>
        </div>
      </div>
      <el-checkbox class="mt-1" v-model="formbuilderFiltersData.isSaveFilter"
        >Save this filter for future use ?</el-checkbox
      >
      <el-checkbox
        class="mt-1"
        v-model="formbuilderFiltersData.updateFilter"
        v-if="formbuilderFiltersData._id"
        >Update this filter?</el-checkbox
      >
    </el-col>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { postAPICall } from "../../helpers/httpHelper";
import { fetchGlobalVariables } from "@/repo/globalVariables";
import { fetchEntityById } from "../../repo/entityRepo";
import { getAllFieldsArrayFromEntity } from "../../utils/formatter";
export default {
  components: {
    // CustomDatePicker: () => import("@/components/widgets/customDatePicker.vue"),
    FormbuilderFilterRow: () =>
      import("@/components/formBuilders/formbuilderFilterRow.vue"),
  },
  computed: {
    ...mapGetters("globalVariables", ["getAllGlobalVariables"]),
    ...mapGetters("auth", ["getDefaultDateFormat"]),
    entilistAsOptions() {
      return (filter) => {
        let field = this.allFormbuilderFields.find(
          (e) => e.key == filter.field
        );
        if (
          field &&
          field.entity_id &&
          this.entityDataInfo &&
          this.entityDataInfo.length
        ) {
          let selectedEntity = this.entityDataInfo.find(
            (e) => e.entity_id === field.entity_id
          );
          if (selectedEntity && selectedEntity.data) {
            return selectedEntity.data;
          }
        } else {
          return [];
        }
      };
    },
  },
  data() {
    return {
      weekdays_options: [
        { name: "Monday", value: 1, key: "MON" },
        { name: "Tuesday", value: 2, key: "TUE" },
        { name: "Wednesday", value: 3, key: "WED" },
        { name: "Thursday", value: 4, key: "THU" },
        { name: "Friday", value: 5, key: "FRI" },
        { name: "Saturday", value: 6, key: "SAT" },
        { name: "Sunday", value: 0, key: "SUN" },
      ],
      users: [],
      starRating_options: [
        { name: "1", value: 1 },
        { name: "1.5", value: 1.5 },
        { name: "2", value: 2 },
        { name: "2.5", value: 2.5 },
        { name: "3", value: 3 },
        { name: "3.5", value: 3.5 },
        { name: "4", value: 4 },
        { name: "4.5", value: 4.5 },
        { name: "5", value: 5 },
      ],
      everyYearFilters: ["this_year", "last_year"],
      allowedLoginFilterOp: [
        "=text-includes",
        "=case-insensitive",
        "=case-sensitive",
      ],
      default_relational_filter_query: "includes",

      newFilterData: {
        field: "",
        entity_id: "",
        template_id: "",
        operator: "",
        value: "",
        value_type: "",
        value_source: "",
        data_type: "",
        query_type: "AND",
        value_field: "",
        validations: {
          data_type: "",
        },
        relation_entity_id: "",
        relational_filter_query: "includes",
        isUserFilter: false,
        grouping: {},
      },
      newGroupingFilter: {
        grouping_query_type: "AND",
        groupingFilters: [],
      },
      query_type: "AND",
      operatorsMap: {
        NUMBER: [
          {
            title: "Equals (=)",
            value: "=",
          },
          {
            title: "Greater Than (>)",
            value: ">",
          },
          {
            title: "Greater Than or Equal(>=)",
            value: ">=",
          },
          {
            title: "Less Than (<)",
            value: "<",
          },
          {
            title: "Less Than or Equal(<=)",
            value: "<=",
          },
          {
            title: "Not Exist",
            value: "notexists",
          },
          {
            title: "Exist",
            value: "exists",
          },
          {
            title: "Range",
            value: "between",
          },
        ],
        PHONE: [
          {
            title: "Exist",
            value: "exists",
          },
          {
            title: "Not Exist",
            value: "notexists",
          },
        ],
        CONCATENATE: [
          {
            title: "Exist",
            value: "exists",
          },
          {
            title: "Not Exist",
            value: "notexists",
          },
        ],
        STRING: [
          {
            title: "Equals (Case-sensitive)",
            value: "=case-sensitive",
          },
          {
            title: "Equals (Case-insensitive)",
            value: "=case-insensitive",
          },
          {
            title: "Text Includes",
            value: "=text-includes",
          },
          {
            title: "Not Exist",
            value: "notexists",
          },
          {
            title: "Exist",
            value: "exists",
          },
          {
            title: "Starts With",
            value: "=starts-with",
          },
          {
            title: " Not Starts With",
            value: "=not-starts-with",
          },
          {
            title: "Ends With",
            value: "=ends-with",
          },
          {
            title: "Not Ends With",
            value: "!ends-with",
          },
        ],
        PAYMENT: [
          {
            title: "In",
            value: "in",
          },
          {
            title: "Not In",
            value: "nin",
          },
          {
            title: "Equals (Case-sensitive)",
            value: "=case-sensitive",
          },
          {
            title: " Not Equals (Case-sensitive)",
            value: "!=case-sensitive",
          },
          {
            title: "Equals (Case-insensitive)",
            value: "=case-insensitive",
          },
          {
            title: " Not Equals (Case-insensitive)",
            value: "!=case-insensitive",
          },
          {
            title: "Exist",
            value: "exists",
          },
          {
            title: "Not Exist",
            value: "notexists",
          },
        ],
        OBJECT_ID: [
          {
            title: "In",
            value: "in",
          },
          {
            title: "Not In",
            value: "nin",
          },
          {
            title: "Not Exist",
            value: "notexists",
          },
          {
            title: "Exist",
            value: "exists",
          },
        ],
        DATE: [
          {
            title: "Real time picker",
            value: "real_time",
          },
          {
            title: "Match with weekdays",
            value: "weekdays",
          },
          {
            title: "Equals (=)",
            value: "=",
          },
          {
            title: "Greater Than (>)",
            value: ">",
          },
          {
            title: "Greater Than or Equal(>=)",
            value: ">=",
          },
          {
            title: "Less Than (<)",
            value: "<",
          },
          {
            title: "Less Than or Equal(<=)",
            value: "<=",
          },
          {
            title: "Not Exist",
            value: "notexists",
          },
          {
            title: "Exist",
            value: "exists",
          },
          {
            title: "Between",
            value: "between",
          },
          {
            title: "NotBetween",
            value: "notbetween",
          },
          {
            title: "Before",
            value: "before",
          },
          {
            title: "After",
            value: "after",
          },
        ],
        TIME: [
          {
            title: "Equals (=)",
            value: "=text-includes",
          },
          {
            title: "Greater Than (>)",
            value: ">",
          },
          {
            title: "Greater Than or Equal(>=)",
            value: ">=",
          },
          {
            title: "Less Than (<)",
            value: "<",
          },
          {
            title: "Less Than or Equal(<=)",
            value: "<=",
          },
          {
            title: "Not Exist",
            value: "notexists",
          },
          {
            title: "Exist",
            value: "exists",
          },
          {
            title: "Between",
            value: "between",
          },
          {
            title: "NotBetween",
            value: "notbetween",
          },
        ],
        RELATION: [
          {
            title: "In",
            value: "in",
          },
          {
            title: "Not In",
            value: "nin",
          },
          {
            title: "Not Exist",
            value: "notexists",
          },
          {
            title: "Exist",
            value: "exists",
          },
          {
            title: "Filter",
            value: "filter",
          },
        ],
        FILE: [
          {
            title: "Not Exist",
            value: "notexists",
          },
          {
            title: "Exist",
            value: "exists",
          },
        ],
        ARRAY: [
          {
            title: "In",
            value: "in",
          },
          {
            title: "Not In",
            value: "nin",
          },
          {
            title: "Exist",
            value: "exists",
          },
          {
            title: "Not Exist",
            value: "notexists",
          },
        ],
        DATE_TIME: [
          {
            title: "Exist",
            value: "exists",
          },
          {
            title: "Not Exist",
            value: "notexists",
          },
          {
            title: "Date Includes",
            value: "dateinclude",
          },
          {
            title: "Date Not Includes",
            value: "notdateinclude",
          },
        ],
        WEEKDAYS: [
          {
            title: "Exist",
            value: "exists",
          },
          {
            title: "Not Exist",
            value: "notexists",
          },
          {
            title: "In",
            value: "in",
          },
          {
            title: "Not In",
            value: "nin",
          },
        ],
        TIME_RANGE: [
          {
            title: "Exist",
            value: "exists",
          },
          {
            title: "Not Exist",
            value: "notexists",
          },
          {
            title: "Time includes",
            value: "timeinclude",
          },
        ],
        YES_OR_NO: [
          {
            title: "Equals",
            value: "=case-sensitive",
          },
          {
            title: "Exist",
            value: "exists",
          },
          {
            title: "Not Exist",
            value: "notexists",
          },
        ],
        CURRENCY: [
          {
            title: "Equals (=)",
            value: "=",
          },
          {
            title: "Greater Than (>)",
            value: ">",
          },
          {
            title: "Greater Than or Equal(>=)",
            value: ">=",
          },
          {
            title: "Less Than (<)",
            value: "<",
          },
          {
            title: "Less Than or Equal(<=)",
            value: "<=",
          },
          {
            title: "Not Exist",
            value: "notexists",
          },
          {
            title: "Exist",
            value: "exists",
          },
          {
            title: "Range",
            value: "between",
          },
        ],
        BOOLEAN: [
          {
            title: "In",
            value: "in",
          },
          {
            title: "Not In",
            value: "nin",
          },
          {
            title: "Exist",
            value: "exists",
          },
          {
            title: "Not Exist",
            value: "notexists",
          },
        ],
        DATE_RANGE: [
          {
            title: "Exist",
            value: "exists",
          },
          {
            title: "Not Exist",
            value: "notexists",
          },
          {
            title: "Date includes",
            value: "dateinclude",
          },
        ],
      },

      operatorValueTypeMap: [
        {
          value_type: "VALUE",
          operators: [
            "=",
            "<=",
            "<",
            ">",
            ">=",
            "=case-insensitive",
            "=case-sensitive",
            "=text-includes",
            "!=",
            "dateinclude",
            "timeinclude",
            "in",
            "nin",
            "=starts-with",
            "=not-starts-with",
            "=ends-with",
            "!ends-with",
            "after",
            "before",
          ],
          data_types: [
            "NUMBER",
            "STRING",
            "DATE",
            "TIME",
            "DATE_TIME",
            "TIME_RANGE",
            "YES_OR_NO",
            "CURRENCY",
            "LIST",
            "BOOLEAN",
            "created_at",
            "updated_at",
            "created_by",
            "updated_by",
          ],
        },
        {
          value_type: "GLOBAL_VARIABLE",
          operators: [
            "=",
            "<=",
            ">=",
            "<",
            ">",
            "=case-insensitive",
            "=text-includes",
            "=case-sensitive",
            "!=",
          ],
          data_types: ["NUMBER", "STRING"],
        },
        {
          value_type: "NEW_LIST",
          operators: ["in", "nin"],
          data_types: ["NUMBER"],
        },

        {
          value_type: "ENTITY_DATA_LIST",
          operators: ["in", "nin"],
          data_types: ["OBJECT_ID", "RELATION"],
        },
        {
          value_type: "REAL_TIME_PICKER",
          operators: ["dateinclude"],
          data_types: ["DATE_TIME"],
        },
        {
          value_type: "CURRENT_DATE",
          operators: ["=", "<=", "<", ">", ">="],
          data_types: ["DATE_TIME", "DATE"],
        },
      ],
      globalVariablesList: [],
      globalVariablesListForInputType: {},
      filters: [],
      entityDataInfo: [],
      loginUserFields: [
        {
          value: "email",
          label: "Email",
        },
        {
          value: "first_name",
          label: "First Name",
        },
        {
          value: "last_name",
          label: "Last Name",
        },
      ],
      groupByFieldEntityValues: [],
      pieChartFieldGroupByOptions: [],
      getTemplateFields: [],
      contentFields: [
        "HEADING",
        "PARAGRAPH",
        "HTML_CONTENT",
        "SINGLE_LINE_CONTENT",
        "VIDEO",
        "ACTION_BUTTON",
        "HORIZONTAL_LINE",
        "DIVISION",
      ],
      allEntitiesFilters: [],
      display_views: [
        {
          label: "Table",
          key: "TABLE",
        },
        {
          label: "Cards",
          key: "CARDS",
        },
        {
          label: "Content",
          key: "HTML_CONTENT",
        },
        {
          label: "Board",
          key: "BOARD",
        },
        {
          label: "Charts",
          key: "CHARTS",
        },
      ],
      filteredList: [],
    };
  },
  props: [
    "currentFormbuilder",
    "formbuilderFiltersData",
    "allFormbuilderFields",
  ],
  async mounted() {
    await Promise.all([
      this.fetchGlobalVariables(),
      this.fetchEntityFieldValues(),
    ]);
    if (this.formbuilderFiltersData.filters.length == 0) {
      this.addFilter();
    }
  },
  methods: {
    isFixed(filter) {
      let fieldKey = filter.field;
      let field = this.allFormbuilderFields.find(
        (field) => field.key == fieldKey
      );
      return field.is_fixed;
    },
    async fetchEntityFieldValues() {
      let defaultValueSet = false;
      if (
        this.formbuilderFiltersData.filters &&
        this.formbuilderFiltersData.filters.length
      ) {
        this.formbuilderFiltersData.filters.forEach((element) => {
          if (
            element &&
            (element.data_type == "RELATION" ||
              element.data_type == "OBJECT_ID") &&
            element.relation_entity_id
          ) {
            this.fetchEntityPrimaryFieldsData(element.relation_entity_id);
          }
          if (element?.grouping?.groupingFilters?.length) {
            element.grouping.groupingFilters.forEach((groupedFilter) => {
              if (
                (groupedFilter.data_type === "RELATION" ||
                  groupedFilter.data_type === "OBJECT_ID") &&
                groupedFilter.relation_entity_id
              ) {
                this.fetchEntityPrimaryFieldsData(
                  groupedFilter.relation_entity_id
                );
              }
            });
          }
          if (!defaultValueSet && element.relational_filter_query) {
            this.default_relational_filter_query =
              element.relational_filter_query;
            defaultValueSet = true;
          }
        });
      }
    },
    deleteFilter() {
      this.$emit("delete", {});
    },
    addFilter(targetFilters = null, group_query_type = null) {
      const newFilter = {
        ...JSON.parse(JSON.stringify(this.newFilterData)),
        query_type: group_query_type || this.query_type,
        relational_filter_query: this.default_relational_filter_query,
      };

      if (targetFilters && Array.isArray(targetFilters)) {
        targetFilters.push(newFilter);
      } else if (this.$route.query.routeType) {
        this.formbuilderFiltersData.filters.push({
          ...newFilter,
          isUserFilter: true,
        });
      } else {
        this.formbuilderFiltersData.filters.push(newFilter);
      }

      this.$nextTick(() => {
        const scroll = this.$refs.filterScroll?.wrap;
        if (scroll) scroll.scrollTop = scroll.scrollHeight + 10;
      });
    },
    addGroup(targetFilters = null) {
      const newCondition = {
        ...JSON.parse(JSON.stringify(this.newFilterData)),
        query_type: "AND",
        grouping: {},
        relational_filter_query: this.default_relational_filter_query,
      };

      const groupFilter = {
        ...JSON.parse(JSON.stringify(this.newFilterData)),
        query_type: this.query_type,
        relational_filter_query: this.default_relational_filter_query,
        grouping: {
          grouping_query_type: "AND",
          groupingFilters: [newCondition],
        },
      };

      if (targetFilters && Array.isArray(targetFilters)) {
        targetFilters.push(groupFilter);
      } else if (this.$route.query.routeType) {
        this.formbuilderFiltersData.filters.push({
          ...groupFilter,
          isUserFilter: true,
        });
      } else {
        this.formbuilderFiltersData.filters.push(groupFilter);
      }

      this.$nextTick(() => {
        const scrollbarEl = this.$refs.filterScroll?.wrap;
        if (scrollbarEl) scrollbarEl.scrollTop = scrollbarEl.scrollHeight + 10;
      });
    },
    getCurrentFieldOperators(filter) {
      if (
        filter.field == "status" ||
        filter.data_type == "STATUS" ||
        filter.field == "isCreatedFromFormbuilder"
      ) {
        return [
          {
            title: "In",
            value: "in",
          },
          {
            title: "Not In",
            value: "nin",
          },
        ];
      }
      if (
        filter.data_type == "created_at" ||
        filter.data_type == "updated_at"
      ) {
        return [
          {
            title: "Greater Than (>)",
            value: ">",
          },
          {
            title: "Less Than (<)",
            value: "<",
          },
          {
            title: "Last Month",
            value: "lastmonth",
          },
          {
            title: "This Month",
            value: "thismonth",
          },
        ];
      }
      if (
        filter.data_type == "created_by" ||
        filter.data_type == "updated_by"
      ) {
        return [
          {
            title: "In",
            value: "in",
          },
          {
            title: "Not In",
            value: "nin",
          },
        ];
      }
      if (filter.field) {
        if (filter.data_type) {
          return this.operatorsMap[filter.data_type];
        } else {
          let field = this.allFormbuilderFields.find(
            (field) => field.key == filter.field
          );
          if (
            field &&
            field.data_type &&
            field.result_type &&
            field.result_type.length
          ) {
            return this.operatorsMap[field.result_type];
          } else if (field && field.data_type) {
            return this.operatorsMap[field.data_type];
          } else {
            return [];
          }
        }
      } else {
        return [];
      }
    },
    async checkCurrentFieldData(fieldKey, filter) {
      if (fieldKey == "status") {
        filter.data_type = "STATUS";
        filter.data_source = "VALUE";
        return;
      }
      if (fieldKey == "isCreatedFromFormbuilder") {
        filter.data_type = "isCreatedFromFormbuilder";
        filter.data_source = "VALUE";
        return;
      }
      if (fieldKey == "created_at") {
        filter.data_type = "DATE";
        filter.input_type = "created_at";

        return;
      }
      if (fieldKey == "updated_at") {
        filter.data_type = "DATE";
        filter.input_type = "updated_at";

        return;
      }
      if (fieldKey == "created_by") {
        filter.data_type = "created_by";
        filter.input_type = "created_by";

        return;
      }
      if (fieldKey == "updated_by") {
        filter.data_type = "updated_by";
        filter.input_type = "updated_by";

        return;
      }
      let field = this.allFormbuilderFields.find(
        (field) => field.key == fieldKey
      );
      if (field.inputType == "DATE_TIME" || field.inputType == "DATE") {
        filter.is_date_time = true;
      } else {
        filter.is_date_time = false;
      }
      if (field?.data_table_key) {
        filter.data_table_key = field.data_table_key;
      }
      if (field.input_type == "WEEKDAYS") {
        filter.allow_multiple = field.allow_multiple;
        filter.data_type = this.getTypeFromInputType(field.inputType);
      } else if (field.input_type == "FORMULA") {
        filter.data_type = field.result_type;
        filter.is_formula = true;
      } else if (
        field.input_type == "ENTITY_VARIABLE" &&
        field.inputType == "FORMULA"
      ) {
        filter.data_type = this.getTypeFromInputType(field.result_type);
        field.data_type = this.getTypeFromInputType(field.result_type);
      } else {
        filter.data_type = this.getTypeFromInputType(field.inputType);
        field.data_type = this.getTypeFromInputType(field.inputType);
      }
      if (field.input_type == "RELATION" || field.data_type == "OBJECT_ID") {
        filter.relation_entity_id = field.entity_id;
      }
      this.$set(filter, "data_source", "");
      if (field.inputType == "SELECT" || field.inputType == "MULTI_SELECT") {
        this.$set(filter, "value", []);
      } else {
        this.$set(filter, "value", "");
      }
      filter.input_type = field.input_type;
      await this.getEntilistAsOptions(filter);
    },
    async getEntilistAsOptions(filter) {
      let fieldKey = filter.field;
      let field = this.allFormbuilderFields.find(
        (field) => field.key == fieldKey
      );
      if (field.input_type == "ENTITY" || field.input_type == "RELATION") {
        await this.fetchEntityPrimaryFieldsData(field.entity_id);
      }
    },
    async fetchEntityPrimaryFieldsData(entity_id) {
      try {
        let currentEntity = await fetchEntityById(entity_id);
        let params = {
          entity_id: entity_id,
          template_fields_data: getAllFieldsArrayFromEntity(currentEntity),
          format_data: true,
          filters: [],
        };
        let v2Response = await postAPICall(
          "POST",
          "/entities-data/entity/data/v2",
          params
        );
        const response = v2Response?.data;
        if (response?.data) {
          this.entityDataInfo.push({
            entity: currentEntity,
            data: response.data,
            entity_id: entity_id,
          });
        }
      } catch (err) {
        console.log("Error while fetchEntityPrimaryFieldsData", err);
      }
    },
    getLabel(item, i) {
      let selectedEntity = (this.entityDataInfo || []).find(
        (e) => e.entity_id == item.entity_id
      );
      if (selectedEntity && selectedEntity.entity) {
        selectedEntity = selectedEntity.entity;
      }
      let name =
        item &&
        item.entity_prime_data &&
        Object.keys(item.entity_prime_data) &&
        item.entity_prime_data[Object.keys(item.entity_prime_data)[0]]
          ? item.entity_prime_data[Object.keys(item.entity_prime_data)[0]]
          : "data " + i;
      if (selectedEntity && selectedEntity.primaryFields) {
        let primaryField = selectedEntity.primaryFields[0];
        let key =
          primaryField && primaryField["key"] ? primaryField["key"] : null;
        if (key) {
          name =
            item.entityData &&
            primaryField.template_id &&
            item.entityData[primaryField.template_id]
              ? item.entityData[primaryField.template_id][key + "/name"]
                ? item.entityData[primaryField.template_id][key + "/name"]
                : item.entityData[primaryField.template_id][key]
                ? item.entityData[primaryField.template_id][key]
                : ""
              : "";
          if (!name) {
            name = item.entity_prime_data[key + "/name"]
              ? item.entity_prime_data[key + "/name"]
              : item.entity_prime_data[key];
          }
        }
      }
      return name;
    },
    getTypeFromInputType(inputType) {
      const obj = {
        SINGLE_LINE_TEXT: "STRING",
        MULTI_LINE_TEXT: "STRING",
        DATE: "DATE",
        DATE_TIME: "DATE",
        TIME: "TIME",
        NUMBER: "NUMBER",
        FILE: "FILE",
        SELECT: "ARRAY",
        YES_OR_NO: "YES_OR_NO",
        MULTI_SELECT: "ARRAY",
        CHECKBOX_GROUP: "ARRAY",
        RADIO_BUTTON_GROUP: "ARRAY",
        CHECKBOX: "BOOLEAN",
        RADIO: "STRING",
        HEADING: "STRING",
        SIGNATURE: "FILE",
        GLOBAL_VARIABLE: "OBJECT_ID",
        TEMPLATE_FIELD: "OBJECT_ID",
        ENTITY: "OBJECT_ID",
        IMAGE: "STRING",
        PASSWORD: "STRING",
        MASKED: "STRING",
        EMAIL: "EMAIL",
        PHONE: "PHONE",
        FAX: "NUMBER",
        ZIP_CODE: "ZIP_CODE",
        CONCATENATE: "CONCATENATE",
        CURRENCY: "NUMBER",
        PHONE_COUNTRY_CODE: "PHONE",
        QUESTION: "STRING",
        DATE_TIME_RANGE: "DATE_TIME",
        DATE_RANGE: "DATE_RANGE",
        WEEKDAYS: "WEEKDAYS",
        TIME_RANGE: "TIME_RANGE",
        RELATION: "RELATION",
        LIST: "ARRAY",
        Hyper_link: "STRING",
        STAR_RATING: "ARRAY",
        PAY_BUTTON: "PAYMENT",
        AGGREGATE_FUNCTION: "NUMBER",
        AUTO_INCREMENT_NUMBER: "STRING",
      };
      return obj[inputType];
    },
    allowedDataSources(filter) {
      let operatorValues = this.operatorValueTypeMap.filter((valueType) => {
        return (
          valueType.operators.indexOf(filter.operator) > -1 &&
          valueType.data_types.indexOf(filter.data_type) > -1
        );
      });
      return operatorValues.map((e) => e.value_type);
    },
    async checkSourceDataChange(source, filter) {
      if (
        filter.data_type == "created_by" ||
        filter.data_type == "updated_by"
      ) {
        return;
      }
      if (source == "GLOBAL_VARIABLE") {
        // await this.getGlobalVariables(source, filter);
        // we have to fetch global variables
      }
    },
    removeFilterFromList(index, subIndex = null) {
      const filteredList = this.formbuilderFiltersData.filters;
      const filterToRemove = filteredList[index];
      if (!filterToRemove) return;

      if (subIndex !== null) {
        const groupParent = this.formbuilderFiltersData.filters.find(
          (filter) => filter === filterToRemove
        );
        if (
          groupParent &&
          groupParent.grouping &&
          Array.isArray(groupParent.grouping.groupingFilters)
        ) {
          groupParent.grouping.groupingFilters.splice(subIndex, 1);

          if (groupParent.grouping.groupingFilters.length === 0) {
            const groupIndex = this.formbuilderFiltersData.filters.findIndex(
              (filter) => filter === groupParent
            );
            if (groupIndex > -1) {
              this.formbuilderFiltersData.filters.splice(groupIndex, 1);
            }
          }
        }
      } else {
        const originalIndex = this.formbuilderFiltersData.filters.findIndex(
          (filter) => filter === filterToRemove
        );
        if (originalIndex > -1) {
          this.formbuilderFiltersData.filters.splice(originalIndex, 1);
        }
      }
    },
    checkTemplateCondition(filter) {
      if (
        filter.data_type != "created_by" &&
        filter.data_type != "updated_by" &&
        filter.operator != "filter"
      ) {
        return true;
      }
    },
    checkIsSelect(filter) {
      let field = this.allFormbuilderFields.find(
        (field) => field.key == filter.field
      );
      if (
        field &&
        (field.inputType == "SELECT" ||
          field.inputType == "MULTI_SELECT" ||
          field.inputType == "CHECKBOX_GROUP" ||
          field.input_type == "RADIO_BUTTON_GROUP" ||
          field.inputType == "LIST" ||
          field.input_type == "WEEKDAYS" ||
          field.inputType == "STAR_RATING" ||
          field.input_type == "PAY_BUTTON")
      ) {
        return true;
      }
      return false;
    },
    getSelfTemplateFieldsByType(filter) {
      let field = this.allFormbuilderFields.find(
        (field) => field.key == filter.field
      );
      if (
        (field && field.inputType === "NUMBER") ||
        field.inputType === "CURRENCY" ||
        field.inputType === "AGGREGATE_FUNCTION" ||
        (field.inputType === "FORMULA" && field.result_type === "NUMBER")
      ) {
        return (this.allFormbuilderFields || []).filter(
          (e) =>
            (e.data_type === "NUMBER" ||
              (e.input_type === "FORMULA" && e.result_type !== "DATE") ||
              e.input_type === "AGGREGATE_FUNCTION" ||
              (e.input_type === "ENTITY_VARIABLE" &&
                e.inputType === "NUMBER")) &&
            e.key !== field.key
        );
      }
      if (
        (field && field.inputType === "DATE") ||
        field.inputType === "FORMULA"
      ) {
        return (this.allFormbuilderFields || []).filter(
          (e) =>
            (e.data_type === "DATE" ||
              (e.input_type === "FORMULA" && e.result_type === "DATE")) &&
            e.key !== field.key
        );
      } else if (field && field.input_type) {
        return (this.allFormbuilderFields || []).filter(
          (e) =>
            e?.key &&
            ((field.inputType != "ENTITY" && e.inputType == field.inputType) ||
              (field.inputType == "ENTITY" &&
                field.entity_id == e.entity_id &&
                e.inputType == "ENTITY") ||
              (["MULTI_SELECT", "SELECT"].indexOf(field.inputType) != -1 &&
                ["MULTI_SELECT", "SELECT"].indexOf(e.inputType) != -1) ||
              (["TIME", "TIME_RANGE"].indexOf(field.inputType) != -1 &&
                ["TIME", "TIME_RANGE"].indexOf(e.inputType) != -1)) &&
            e.key != field.key
          // e.relationship_key != this.field.key
        );
      }

      return [];
    },
    checkCurrentFieldValue(field, filter) {
      filter.value = field;
    },
    parseOptionsAsNumbers(data, filter) {
      if (filter.data_source == "NEW_LIST" && filter.data_type == "NUMBER") {
        filter.value = filter.value.map((e) => +e);
      }
    },
    async fetchGlobalVariables() {
      try {
        const query = { get_all: true };
        let [globalVariables] = await Promise.all([
          fetchGlobalVariables(query),
        ]);
        // await this.$store.dispatch(
        //   "globalVariables/fetchGlobalVariables",
        //   query
        // );
        if (globalVariables?.data) {
          this.globalVariablesList = [...globalVariables.data];
        }
      } catch (err) {
        console.log(err);
      }
    },
    addGlobalVaraibleData(value, filter) {
      let selectedGlobalVariable = this.selectedGlobalVariablesList(
        filter
      ).find((e) => e._id == value);
      if (selectedGlobalVariable?.value) {
        filter.value = selectedGlobalVariable.value;
      }
    },
    selectedGlobalVariablesList(filter) {
      let field = this.allFormbuilderFields.find((e) => e.key == filter.field);
      return this.globalVariablesList.filter(
        (x) => x && field && x.input_type == field.input_type
      );
    },
    fieldType(filter, type) {
      if (filter.field) {
        let field = this.allFormbuilderFields.find(
          (field) => field.key == filter.field
        );
        return field?.input_type == type;
      }
      return [];
    },
    getCurrentFieldOptions(filter) {
      if (filter.selectField === "created_at") {
        filter.data_type = "DATE";
        filter.input_type = "created_at";
        return;
      }
      if (filter.selectField === "updated_at") {
        filter.data_type = "DATE";
        filter.input_type = "updated_at";
        return;
      }
      if (filter.selectField === "created_by") {
        filter.data_type = "created_by";
        filter.input_type = "created_by";
        return;
      }
      if (filter.selectField === "updated_by") {
        filter.data_type = "updated_by";
        filter.input_type = "updated_by";
        return;
      }
      if (filter.field) {
        let field = this.allFormbuilderFields.find(
          (field) => field.key == filter.field
        );
        if (field?.input_type == "LIST" && field?.list_data) {
          return field.list_data;
        }
        if (field && field.input_type == "PAY_BUTTON" && field.pay_status) {
          return field.pay_status;
        } else if (field?.input_type == "WEEKDAYS") {
          let weekdays_names = this.weekdays_options.map(
            (weekday) => weekday.name
          );
          return weekdays_names;
        } else if (
          field?.input_type == "STAR_RATING" ||
          (field?.input_type == "ENTITY_VARIABLE" &&
            field?.inputType == "STAR_RATING")
        ) {
          let starRating_values = this.starRating_options.map(
            (starRating) => starRating.value
          );
          return starRating_values;
        } else {
          return field?.options || [];
        }
      } else {
        return [];
      }
    },
  },
};
</script>

<style lang="scss">
.filter-table {
  border-collapse: separate;
  border-spacing: 0 6px;
  width: 100%;
}
.filter-table tr {
  background-color: white;
  border-radius: 6px;
}
</style>
